'use strict'

const uuid = require('uuid')
const omit_ = require('lodash/omit')

const { isPristine } = require('./symbols')

// getRecordId :: Record -> RecordId
const getRecordId = record => record._id

// hasDraft :: Record -> Bool
const hasDraft = record => typeof record[isPristine] === 'boolean'

// isPristine :: Record -> Boolean
const isRecordPristine = record => !hasDraft(record) || record[isPristine]

// setPristineState :: (Record, Boolean) -> Record
const markRecordDirty = record =>
  Object.assign({}, record, { [isPristine]: false })

// createDraft :: (Record, Record) -> Record
const createDraft = (record, defaultDraft) =>
  Object.assign({}, defaultDraft, {
    _id: record._id || uuid.v4(),
    [isPristine]: true
  })

// isSameRecord :: (Record, Record) -> Boolean
const isSameRecord = (a, b) => a && b && a._id === b._id

const cleanseRecord = record =>
  record != null ? omit_(record, [isPristine]) : null

module.exports.cleanseRecord = cleanseRecord
module.exports.createDraft = createDraft
module.exports.getRecordId = getRecordId
module.exports.hasDraft = hasDraft
module.exports.isRecordPristine = isRecordPristine
module.exports.isSameRecord = isSameRecord
module.exports.markRecordDirty = markRecordDirty



// WEBPACK FOOTER //
// ./record-store/records.js